

<template>
<div>
<v-container>
<v-row>
<v-col cols="12" sm="12" lg="12">
   <opcion></opcion>
</v-col>
</v-row>   
</v-container>
   
</div>
</template>

<script>

import opcion from '@/components/opcion/Opcion.vue';



export default {
    data () {
    return {
              
    }
  },
  components: {
    
    opcion
    
  },

  methods: {

}

}
    

</script>


